import axios from 'axios'
import ui from '@/store/uiControll'
import api from '@/config/api'
import apiNames from '@/config/apiNames'
import { commonUtil } from '@/util'

// AA00 CSRF-TOKEN発行
const getCsrfToken = async () => {
  const ret = await axios
    .get(api.CSRF)
    // .get(apiMock.CSRF)
    .then((response) => {
      return true
    })
    .catch((error) => {
      commonUtil.afterApiFailProcess(error.response)
      return false
    })
  return ret
}

export default getCsrfToken
